export const MainPhotos = (open) => {
  return [
    {
      id: 1,
      class: 'textfield',
      name: 'dominio',
      label: 'Dominio',
      value: open.data.dominio,
      disabled: true,
      sm: 6,
      xs: 6,
    },
    {
      id: 2,
      class: 'textfield',
      name: 'nrodev',
      value: open.data.nrodev,
      label: 'Nº de V',
      disabled: true,
      sm: 6,
      xs: 6,
    },
    {
      id: 3,
      class: 'textfield',
      name: 'brand',
      value: open.data.marca,
      label: 'Marca',
      disabled: true,
      sm: 6,
      xs: 6,
    },
    {
      id: 4,
      class: 'textfield',
      name: 'modelo',
      value: open.data.modelo,
      label: 'Modelo',
      disabled: true,
      sm: 6,
      xs: 6,
    },
    {
      id: 5,
      class: 'textfield',
      name: 'año',
      value: open.data.año,
      label: 'Año',
      disabled: true,
      sm: 6,
      xs: 6,
    },
    {
      id: 6,
      class: 'textfield',
      name: 'color',
      value: open.data.color,
      label: 'Color',
      disabled: true,
      sm: 6,
      xs: 6,
    },
  ]
}
